export const anchorLinks = [
  {
    anchor: 'team',
    alias: '#team',
    title: 'Speakers',
  },
  {
    anchor: 'program',
    alias: '#program',
    title: 'Agenda',
  },
  {
    anchor: 'address',
    alias: '#address',
    title: 'Event Location',
  },
];
